import { OnlineContractingStateEnum } from 'v3/data/store/onlineContracting/enums';

type MappingValue = {
  name: string;
  title: string;
};

type OnlineContractingStateMappingType = Record<OnlineContractingStateEnum, MappingValue>;

export const OnlineContractingStateMapping: OnlineContractingStateMappingType = {
  CONTRATACAO_INICIADA: {
    name: 'ContratacaoIniciada',
    title: 'Contratação Iniciada',
  },
  PROCESSANDO_ANALISE_CREDITO: {
    name: 'ProcessandoAnaliseCredito',
    title: 'Processando Análise de Crédito',
  },
  ANALISE_CREDITO_REPROVADA: {
    name: 'AnaliseCreditoReprovada',
    title: 'Análise de Crédito Reprovada',
  },
  AGUARDANDO_GERACAO_PROPOSTA: {
    name: 'AguardandoGeracaoProposta',
    title: 'Aguardando Geração de Proposta',
  },
  AGUARDANDO_SELFIE: {
    name: 'AguardandoSelfie',
    title: 'Aguardando Selfie',
  },
  CONTRATACAO_FINALIZADA: {
    name: 'ContratacaoFinalizada',
    title: 'Contratação Finalizada',
  },
  CPF_BLOQUEADO: {
    name: 'CpfBloqueado',
    title: 'CPF Bloqueado',
  },
  AGUARDANDO_ACEITE_PROPOSTA: {
    name: 'AguardandoAceiteProposta',
    title: 'Aguardando Aceites da Proposta',
  },
  CONTRATACAO_NEGADA: {
    name: 'ContratacaoNegada',
    title: 'Contratação Negada',
  },
  CHAVE_EXPIRADA: {
    name: 'ChaveExpirada',
    title: 'Chave Expirada',
  },
  AGUARDANDO_PAGAMENTO_ENTRADA: {
    name: 'AguardandoPagamentoEntrada',
    title: 'Aguardando Pagamento da Entrada',
  },
  AGUARDANDO_FATURAMENTO: {
    name: 'AguardandoFaturamento',
    title: 'Aguardando Faturamento',
  },
  PROCESSANDO_FATURAMENTO: {
    name: 'ProcessandoFaturamento',
    title: 'Processando Faturamento',
  },
  PROCESSANDO_CANCELAMENTO: {
    name: 'ProcessandoCancelamento',
    title: 'Processando Cancelamento',
  },
};
